@let _icon = icon();

<div class="notify" [ngClass]="'notify-color-' + color()">
  @if (_icon) {
    <div class="notify-icon">
      <app-svg-icon [name]="_icon"></app-svg-icon>
    </div>
  }

  <div class="notify-content">
    <div>
      <ng-content></ng-content>
    </div>
    @if (copyData()) {
      <app-copy-button [data]="copyData()" />
    }
  </div>

  @if (showClose()) {
    <div class="notify-close" (click)="closeElement.emit()" (keydown.enter)="closeElement.emit()" (keydown.space)="closeElement.emit()" tabindex="0">
      <svg width="40" height="40" viewBox="0 0 40 40" fill="none" stroke="currentColor" xmlns="http://www.w3.org/2000/svg">
        <path d="M30 10L10 30" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M10 10L30 30" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </div>
  }
</div>
